const actionTypes = require('constants/actionTypes');
const Api = require('../services/api');
const apiURLBuilder = require('../core/apiURLBuilder');

const showHeader = () => {
    return {
        type: actionTypes.SHOW_HEADER,
    };
};

const hideHeader = () => {
    return {
        type: actionTypes.HIDE_HEADER,
    };
};

const setIsSmallHeaderStyle = (payload) => {
    return {
        type: actionTypes.SET_IS_SMALL_HEADER_STYLE,
        payload,
    };
};

const getLogo = () => dispatch => {
    const saveRequestData = {
        header: {},
        query: {
            language: __ORIGIN_COUNTRY__.toLowerCase(),
            originCountry: __ORIGIN_COUNTRY__,
        },
    };

    return Api.get(apiURLBuilder.getURL('getTopBarCMSContent'), saveRequestData).then(res => {
        return dispatch({
            type: actionTypes.LOAD_LOGO,
            customLogoNavbarUrl: {
                logo: res.body.topbar.custom_logo_navbar.url,
                icon: res.body.topbar.custom_icon_onboarding.url,
            },
        });
    });
};

export default {
    showHeader,
    hideHeader,
    getLogo,
    setIsSmallHeaderStyle,
};
